'use client';

import { ReactNode } from 'react';

import { FlagsProvider } from 'flagged';

const FlagProvider = ({ children }: { children: ReactNode }) => {
  const PUBLIC_FEAUTRE_FLAGS = process.env.NEXT_PUBLIC_FEATURE_FLAGS ?? '';
  const featureList: string[] =
    PUBLIC_FEAUTRE_FLAGS?.split(',').map((x) => x?.trim()) || [];

  return <FlagsProvider features={featureList}>{children} </FlagsProvider>;
};

export default FlagProvider;
